(function () {
  if (window.HorizontalScrollSectionLoaded) {
    if (window.HorizontalScrollSectionInit) window.HorizontalScrollSectionInit(document);
    return;
  }

  window.HorizontalScrollSectionLoaded = true;

  var selector = '[data-horizontal-scroll]';
  var instances = new WeakMap();
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function readCssNumber(element, name, fallback) {
    var value = window.getComputedStyle(element).getPropertyValue(name);
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function destroy(section) {
    var instance = instances.get(section);
    if (!instance) return;

    window.removeEventListener('scroll', instance.onScroll);
    window.removeEventListener('resize', instance.onResize);
    if (instance.resizeObserver) instance.resizeObserver.disconnect();
    instance.track.style.transform = '';
    instance.headings.forEach(function (heading) {
      heading.style.transform = '';
    });
    instances.delete(section);
  }

  function update(instance) {
    if (instance.disabled) return;

    var rect = instance.scroller.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1;
    var scrollable = Math.max(1, rect.height - viewportHeight);
    var travelProgress = clamp(-rect.top / scrollable, 0, 1);
    var maxTranslate = Math.max(0, instance.track.scrollWidth - viewportWidth);
    var fallbackTranslate = Math.max(0, instance.items.length - 1) * viewportWidth;
    var x = -travelProgress * (maxTranslate || fallbackTranslate);

    instance.track.style.transform = 'translate3d(' + x + 'px, 0, 0)';

    var segment = 1 / instance.items.length;
    instance.headings.forEach(function (heading, index) {
      var localProgress = clamp((travelProgress - index * segment) / segment, 0, 1);
      var headingX = instance.headingMotion - localProgress * instance.headingMotion * 2;
      var middleWeight = 1 - Math.abs(localProgress - 0.5) * 2;
      var headingScale = 1 + middleWeight * instance.headingScale;
      heading.style.transform = 'translate3d(' + headingX + 'vw, 0, 0) scale(' + headingScale + ')';
    });
  }

  function initSection(section) {
    destroy(section);

    var track = section.querySelector('[data-horizontal-scroll-track]');
    var scroller = section.querySelector('[data-horizontal-scroll-scroller]');
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-horizontal-scroll-panel]'));
    var headings = Array.prototype.slice.call(section.querySelectorAll('[data-horizontal-scroll-heading]'));
    var disabled = reduceMotion.matches || mobileQuery.matches;

    if (!track || !scroller || items.length < 2 || disabled) return;

    var instance = {
      disabled: false,
      section: section,
      scroller: scroller,
      track: track,
      items: items,
      headings: headings,
      headingMotion: readCssNumber(section, '--horizontal-scroll-panel-heading-motion', 45),
      headingScale: readCssNumber(section, '--horizontal-scroll-panel-heading-scale', 4) / 100,
      ticking: false
    };

    instance.onScroll = function () {
      if (instance.ticking) return;
      instance.ticking = true;
      window.requestAnimationFrame(function () {
        update(instance);
        instance.ticking = false;
      });
    };

    instance.onResize = function () {
      update(instance);
    };

    if ('ResizeObserver' in window) {
      instance.resizeObserver = new ResizeObserver(instance.onResize);
      instance.resizeObserver.observe(scroller);
      instance.resizeObserver.observe(track);
    }

    instances.set(section, instance);
    window.addEventListener('scroll', instance.onScroll, { passive: true });
    window.addEventListener('resize', instance.onResize);
    update(instance);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(selector)) {
      initSection(scope);
    }
    scope.querySelectorAll(selector).forEach(initSection);
  }

  function refreshAll() {
    document.querySelectorAll(selector).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(selector).forEach(destroy);
  });

  if (reduceMotion.addEventListener) {
    reduceMotion.addEventListener('change', refreshAll);
    mobileQuery.addEventListener('change', refreshAll);
  }

  window.HorizontalScrollSectionInit = initAll;
})();
